import React from 'react';
import clsx from 'clsx';
import { FormControlLabel, ListItemText } from '@material-ui/core';
import globalStyles from 'styles/globalStyles';
import { ApariCheckbox } from 'components';
import styles from './styles';
import CircleCheckedFilled from '@material-ui/icons/CheckCircle';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';

type Props = {
    name?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    checked?: boolean;
    disabled?: boolean;
    primaryBorderColor?: boolean;
    invertedColors?: boolean;
    darkBackground?: boolean;
    text: string;
    round?: boolean;
    className?: string;
    labelClassName?: string;
};

const ApariCheckboxWithLabel: React.FC<Props> = props => {
    const { text, darkBackground, round, className, labelClassName, ...rest } = props;
    const classes = styles();
    const globalClasses = globalStyles();
    return (
        <div className={clsx(globalClasses.flexRowStart, classes.control, className)}>
            <FormControlLabel
                control={
                    <ApariCheckbox
                        {...(round && {
                            icon: <CircleUnchecked className={clsx(classes.apari80)} />,
                            checkedIcon: <CircleCheckedFilled className={clsx(classes.apari80)} />,
                            disableRipple: true
                        })}
                        {...rest}
                    />
                }
                label={
                    <ListItemText
                        disableTypography
                        className={clsx(
                            globalClasses.flexColumnCenter,
                            classes.labelMargin,
                            darkBackground ? globalClasses.font12weight600Dark : globalClasses.font12weight600,
                            labelClassName
                        )}
                        primary={text}
                    />
                }
            />
        </div>
    );
};

export default ApariCheckboxWithLabel;
